export const SEARCH_SUGGESTIONS = [

  "Tyre Scrap",

  "Pyro Oil",

  "Tyre Steel Scrap",

  "Baled Tyres PCR",

  "Baled Tyres TBR",

  "Three Piece PCR",

  "Three Piece TBR",

  "Shreds",

  "PCR Mulch",

  "Rubber Granules/Crumb",

  "Pyro Steel",

  "Rubber Crumb Steel",
];


export const CATEGORY_LINKS = [

  {
    label: "All Categories",
    path: "/our-products",
  },

  {
    label: "Tyre Scrap",
    path:
      "/our-products?category=Tyre%20Scrap",
  },

  {
    label: "Pyro Oil",
    path:
      "/our-products?category=Pyro%20Oil",
  },

  {
    label: "Tyre Steel Scrap",
    path:
      "/our-products?category=Tyre%20Steel%20Scrap",
  },
];